<div class="assist-banner-container">
    <div class="travel-banner-window" #bannerWindow>
        
        <!-- Parallax Media Layer (Window aperture scroll effect) -->
        <div class="banner-parallax-media"
             [style.transform]="parallaxTransform">
            <!-- Thumbnail poster shown immediately till video is fetched -->
            <img *ngIf="posterUrl"
                 [src]="posterUrl"
                 class="banner-poster-bg"
                 [class.fade-out]="isVideoLoaded"
                 alt="Mihuru Travel Destination"
                 loading="eager" />
            <video
                #bannerVideo
                class="banner-video-bg"
                [class.loaded]="isVideoLoaded"
                autoplay
                muted
                loop
                playsinline
                preload="auto"
                [poster]="posterUrl"
                (canplay)="onVideoCanPlay()"
                (loadeddata)="onVideoCanPlay()"
            >
                <source *ngIf="videoBlobUrl" [src]="videoBlobUrl" type="video/mp4">
                <ng-container *ngIf="!videoBlobUrl">
                    <source *ngFor="let s of candidateSources" [src]="s.url" [type]="s.type">
                </ng-container>
            </video>
        </div>

        <!-- Glass Specular Sheen & Depth Overlays -->
        <div class="window-glass-sheen"></div>
        <div class="window-inner-bevel"></div>
        <div class="banner-gradient-overlay"></div>

        <!-- Front Floating Banner Content -->
        <div class="banner-content">
            <h2 class="banner-title">
                The <span class="highlight-white">world</span> is <span class="highlight-yellow">yours</span>
            </h2>
            <p class="banner-subtitle">Go experience it now, and pay later with Mihuru</p>
        </div>
    </div>
</div>